/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from "axios";
import { Message } from "element-ui";
import { getUrlParam } from "@/utils/common";

/**
 * 请求失败后的错误统一处理，500，503需要有后续处理，故没有拦截
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = status => {
  // 状态码判断
  let logoutNotice = sessionStorage.getItem("logoutNotice");
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      if (navigator.userAgent.match(/axpzhkt/i)) {
        //将上次获取token时间设置成过去10分钟
        var lasttime = new Date().getTime() - 10 * 60 * 1000;
        window.sessionStorage.setItem("lastTokenTime", lasttime);
        alert(JSON.stringify({ type: 402 }));
      } else {
        if (!logoutNotice || logoutNotice == 0) {
          sessionStorage.setItem("logoutNotice", 1);
          Message({
            message: "您已退出，请重新登录",
            offset: 350,
            duration: 1500,
            onClose: function() {
              sessionStorage.setItem("logoutNotice", 0);
              let _b = window.localStorage.getItem("lw_schoolIp");
              if (!_b) {
                _b = "https://web.etiantian.com/digitalschool/";
              }
              window.sessionStorage.removeItem("token");
              window.location.href = _b;
            }
          });
        }
      }

      break;
    // 404请求不存在
    case 404:
      break;
    default:
      break;
  }
};

// 创建axios实例
var instance = axios.create({ timeout: 1000 * 10 });
// 设置post请求头
instance.defaults.headers.post["Accept"] =
  "application/json, text/javascript, */*; q=0.01";
// instance.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded; charset=UTF-8";
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    let token = "";
    if (navigator.userAgent.match(/axpzhkt/i)) {
      let timestamp = new Date().getTime();
      let lasttime = window.sessionStorage.getItem("lastTokenTime");
      if (lasttime && timestamp - lasttime < 5 * 60 * 1000) {
        token = "Bearer " + window.sessionStorage.getItem("token");
      } else {
        let parameter_token = androidProxy.getToken();
        token = "Bearer " + parameter_token;
        window.sessionStorage.setItem("token", parameter_token);
        window.sessionStorage.setItem("lastTokenTime", timestamp);
      }
    } else {
      token = sessionStorage.getItem("token");
      if (!token) {
        let urltoken = getUrlParam("token");
        if (urltoken) {
          token = urltoken;
        }
      }
    }

    config.headers.Authorization = "Bearer " + token;

    //防止ie11下get请求被缓存
    if (config.method == "get") {
      config.params = {
        r: Math.random(),
        ...config.params
      };
    }

    return config;
  },
  error => Promise.error(error)
);

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    if (res.status === 200 || res.status === 201) {
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res.data);
    }
  },

  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      if (response.status === 500 || response.status === 503) {
        return Promise.resolve(response);
      } else {
        errorHandle(response.status, response.data.message);
        return Promise.reject(response);
      }
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      //store.commit("changeNetwork", false);
    }
  }
);

export default instance;
